import { ExpandedEventInUrl } from '@app/enums';
import { RouteName } from '@app/router/constants/RouteName';
import { getEventSlugFromEvent } from '@modules/eventDetailsPage/utils';
import { BET_BUILDER_GROUP_ID } from '@modules/eventGrid/components/EventRow/marketGroupHelpers';
import { getUniqueTournamentId } from '@store/modules/ui/sportOffer/marketFilters/helpers';
import {
    useVuexStore,
    useVueRouter,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    Ref,
    ref,
    watch,
} from '@vue/composition-api';
import { betBuilderService } from '../services/betBuilder';
import { BetBuilderStore } from '../store';
import OfferEvent from '@core/models/offer/OfferEvent';

export const useBBEventCardLabeling = (event: Ref<OfferEvent>) => {
    const betBuilderStore = useVuexStore<BetBuilderStore>('data/betBuilder');

    const isBBEventCardLabelEnabled = betBuilderStore.getter('isEventCardLabelEnabled');
    const isEventPreMatch = computed(() => event.value.hasPreMatchBetting());
    const isEventBetBuilder = ref(false);

    watch(() => event.value.id, async (newValue) => {
        isEventBetBuilder.value = await betBuilderService.isEventBetBuilder(newValue);
    }, {
        immediate: true,
    });

    const isBBEventCardLabelVisible = computed(() => isBBEventCardLabelEnabled.value && isEventPreMatch.value && isEventBetBuilder.value);

    const { router } = useVueRouter();

    const route = computed(() => {
        const { route } = router.value.resolve({
            name: RouteName.Sport.OfferEvent,
            params: { eventSlug: getEventSlugFromEvent(event.value) },
            query: {
                [ExpandedEventInUrl.type]: getUniqueTournamentId(
                    'offer',
                    event.value.tournamentId,
                    event.value.isOngoing(),
                ),
                [ExpandedEventInUrl.marketGroup]: BET_BUILDER_GROUP_ID.toString(),
            },
        });
        return route;
    });

    return {
        isBBEventCardLabelVisible,
        route,
    };
};
